export default function initProjectLabels() {
    const projectLabels = document.querySelectorAll('[data-project-label]');

    if (!projectLabels.length) {
        return;
    }

    const updateVisibility = () => {
        projectLabels.forEach((projectLabel) => {
            const parsedThreshold = Number.parseInt(projectLabel.dataset.scrollThreshold, 10);
            const threshold = Number.isNaN(parsedThreshold) ? 0 : parsedThreshold;
            projectLabel.classList.toggle('is-visible', window.scrollY >= threshold);
        });
    };

    let updateRequested = false;

    window.addEventListener('scroll', () => {
        if (updateRequested) {
            return;
        }

        updateRequested = true;

        window.requestAnimationFrame(() => {
            updateVisibility();
            updateRequested = false;
        });
    }, { passive: true });

    updateVisibility();
}
